import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Flex,
  TreeSelect,
  notification,
  Typography,
  Dropdown,
} from "antd";
import {
  DeleteOutlined,
  QuestionCircleOutlined,
  ExpandOutlined,
  ShrinkOutlined,
  DownOutlined,
  ExportOutlined
} from "@ant-design/icons";
import KitAttributeList from "./KitAttributeList";
import CommonAttributeList from "../common/CommonAttributeList";
import KitProductList from "./KitProductList";
import UploadButton from "../common/UploadButton";
import globalData from "../../config/global_data";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import StatusBadge from "../common/StatusBadge";
import common_api from "../../config/common_api";
import { triggerNotification } from "../common/notify";
import { useAuth } from "../UserAuth/AuthContext";
dayjs.extend(customParseFormat);
const { Text } = Typography;


const KitDrawer = ({ visible, onClose, kidata, setisloader, onProductCreate }) => {
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState(null)
  // const [selectedSku, setSelectedSku] = useState(null);
  const [bundleTitle, setBundleTitle] = useState("New Kit Product");
  const [imageObj, setImageObj] = useState(null);
  const [thumbnailObj, setThumbnailObj] = useState(null);
  const [data, setData] = useState(kidata);
  const [selectedValues, setSelectedValues] = React.useState([]);

  const [savedimages, setSavedimgaes] = useState(null);
  const [savedattributes, setSavedattributes] = useState(null);
  const [removedValues, setRemovedValues] = useState(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const [innerProducts, setInnerProducts] = useState(null);
  const [dropdownImage, setDropdownImage] = useState(null);
  const [savedDropdownImage, setSavedDropdownImage] = useState(null);
  const [hasAttributeError, setHasAttributeError] = useState(false);

  const { userData } = useAuth();


  const ButtonItems = [
    {
      label: 'Save & Draft',
      key: 'saveDraft',
      disabled: true,
    },
    {
      label: 'Save & Reload',
      key: 'saveReload',
      disabled: true,
    },
  ];

  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };


  const onChange = (values) => {
    setSelectedValues(values);
  };

  useEffect(() => { 
    const fetchData = async () => {
      if (globalData && globalData.all_cat_list && globalData.all_cat_list.length > 0) {
        let cattree = await globalData.all_cat_list.filter(item => item.store_id === kidata.store_id)
        if (cattree && cattree.length > 0) {
          setTreeData(cattree[0].treedata)
        }
      }

      if (data.kit_img_key.id) {
        data.kit_img_key.url_standard = data.kit_img_key.value
        setDropdownImage({ img_data: [data.kit_img_key] });
      }
      form.setFieldsValue({
        msrpPrice: data.currency_symbol + '' + data.prod_msrp,
        salePrice: data.currency_symbol + '' + data.prod_sale_price,
        SAPmsrp: data.sapMsrp,
        SAPPrice: data.sapPrice,
        KitName: data.kitname,
        DropdownText: data.select_kit_name.value,
        DiscountValue: data.discount.value,
        store: data.store,
        LastUpdate: data.lastUpdated,
        sapSku: data.bcSku,
        SaleMsrp: data.msrp,
        status: data.active,

        // salePrice: data.sale_price
      });
    }
    if (kidata.categories.length > 0) {
      const categoriesStringArray = kidata.categories.map(String);

      setSelectedValues(categoriesStringArray)

    } else {
      setSelectedValues([])
    }
    if (kidata && visible) {
      fetchData();
      setData(kidata);
      setBundleTitle(kidata.kitname || "New Simple Product");

      if (kidata.images) {
        if (Array.isArray(kidata.images)) {
          const thumbnailImage = kidata.images.filter(img => img.description === "");
          if (thumbnailImage && thumbnailImage.length) {
            setThumbnailObj({ img_data: thumbnailImage });
          }
        }
      }
    }
  }, [kidata, visible, data, form]);


  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete!',
      message: "Please fix all errors before saving.",
    });
  };
  // const handleInputChange = (name) => (e) => {
  //   const value = e.target.value.replace(/[^\d.]/g, '');
  //   form.setFieldsValue({ [name]: value });
  // };
  const handleInputChange = (name) => (e) => {
    let value = e.target.value;
    // Remove all non-numeric characters (including dot)
    value = value.replace(/[^0-9]/g, '');    
    // Set the cleaned value in the form
    form.setFieldsValue({ [name]: value });
  };
  const handleBlur = () => {
    const bundleName = form.getFieldValue("KitName");
    if (bundleName === "") {
      setBundleTitle(kidata.kitname);
    }
    else if (bundleName) {
      setBundleTitle(bundleName);
    }
  };
  const handleSaveAndPublishClick = () => {
    // Validate SKU selection for all products
   
    if (hasAttributeError) {
      triggerNotification({
        type: 'error',
        title: 'Attribute Error!',
        message: 'Please fix all errors before saving.'
      });
      return;
    }
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };
  const handleSaveAndPublish = async (values) => {

    let images = []
    let available_images = kidata.images
    let custom_fields_final = [], custom_fields_removed = [], currentImageUrls = [];
    let remove_from_GCP = []
    if (savedimages.image_data && savedimages.image_data.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.thumbUrl && item.thumbUrl.startsWith('https://storage.googleapis.com/')) {
          remove_from_GCP.push(item.thumbUrl)
        }
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl,
            is_thumbnail: item.set_as_Featured,
            sort_order: item.img_order
          }
        } else {
          return {
            image_url: item.thumbUrl
          }
        }

      })
    }
    if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      data.forEach(attr => {
        const { values, attribute_key, max_size } = attr;

        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item.val) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "id": item.key,
                "name": baseKey.replace("NUM", counter),
                "value": item.val
              }
            } else if (max_size === 1) {
              itemobj = {
                "id": item.key,
                "name": baseKey,
                "value": item.val
              }
            }
            else {
              itemobj = {
                "id": item.key,
                "name": baseKey + "_" + counter,
                "value": item.val
              }
            }
            if (itemobj.id === "") {
              delete itemobj.id
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }
    if (removedValues && removedValues.custom_fields && removedValues.custom_fields.length > 0) {
      custom_fields_removed = removedValues.custom_fields
    }
    if (innerProducts && innerProducts.length > 0) {
      innerProducts.forEach((item, index) => {
        if (item.value != "undefined") {
          let itemobj = {
            "name": "Bundle_product_" + (parseInt(index) + 1),
            "value": item.value
          }
          if (item.key) {
            itemobj = {
              "id": item.id,
              "name": item.key,
              "value": item.value
            }
          }

          custom_fields_final.push(itemobj)
          if (item.image) {
            if (item.image.is_saved) {
              currentImageUrls.push(item.image.is_saved)
              images.push({
                url_standard: item.image.thumbUrl,
                description: item.value,
                id: item.image.is_saved
              })
            } else if (item.image.id) {
              currentImageUrls.push(item.image.id)
              images.push({
                url_standard: item.image.url_standard,
                description: item.value,
                id: item.image.id
              })
            }
            else if (item.image.thumbUrl) {
              images.push({
                image_url: item.image.thumbUrl,
                description: item.value
              })
            }
            if (item.image.thumbUrl && item.image.thumbUrl.startsWith('https://storage.googleapis.com/')) {
              remove_from_GCP.push(item.image.thumbUrl)
            }
          }
        }

      })
    }

    if (savedDropdownImage && savedDropdownImage.image_data && savedDropdownImage.image_data.length > 0) {
      let imgobj = {
        "name": "KIT_IMG",
        "value": savedDropdownImage.image_data[0].thumbUrl.toString()
      }
      if (data.kit_img_key.id) {
        imgobj.id = data.kit_img_key.id
      }
      custom_fields_final.push(imgobj)
    }

    if (values.DiscountValue) {
      let disobj = {
        "name": "DISCOUNT_%",
        "value": values.DiscountValue.toString()
      }
      if (data.discount.id) {
        disobj.id = data.discount.id
      }
      custom_fields_final.push(disobj)

    }
    if (values.DropdownText) {
      let dropobj = {
        "name": "KIT_PRODUCT_NAME",
        "value": values.DropdownText.toString()
      }
      if (data.select_kit_name.id) {
        dropobj.id = data.select_kit_name.id
      }
      custom_fields_final.push(dropobj)
    }
    const deletedImages =
      (available_images || [])
        .filter(img => !currentImageUrls.includes(img.id) && img.description != "")
        .map(img => img.id);

    let findprimary = null
    let req_data = {
      "store": data.store,
      "store_id": data.store_id,
      "product_id": data.prod_id,
      "data": {
        "name": values.KitName,
        "sku": values.sapSku,
        "images": images && images.length > 0 ? images : [],
        "custom_fields": custom_fields_final,
        "categories": selectedValues
      },
      custom_fields_removed,
      images_removed: deletedImages,
      remove_from_GCP
    }
    if (innerProducts) {
      findprimary = await innerProducts.find(item => item.is_primary == true)
      req_data.data.price = findprimary.msrp.replace(data.currency_symbol, "")
      req_data.data.sale_price = findprimary.sale_price.replace(data.currency_symbol, "")
    }
    setisloader(true)
    let responsedata = await common_api.update_product(req_data)
    if (responsedata) {
      await onProductCreate();
      triggerNotification(responsedata)
    }
    setisloader(false)
    onClose()    
  }
  return (
    <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div className="DrawerButtonBox">
            {data.active == true && kidata.bc_url !== "" && (
              <a href={kidata.bc_url ? kidata.bc_url : ""} target="_blank" title="View on Storefront" style={{ marginRight: 8 }} className="ViewPage" rel="noopener noreferrer">
                <ExportOutlined className="ViewPageIcon" style={{ fontSize: 16, color: 'rgba(0,0,0,0.88)' }} />
              </a>
            )}
            <Button
              className="ExpandDrawer"
              onClick={() => setIsExpanded(!isExpanded)}
              style={{ marginRight: 8 }}
            >
              {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
            </Button>            
            {userData?.data?.access === "ALL" && (
              <Dropdown.Button
                type="primary"
                icon={<DownOutlined />}
                menu={{
                  items: ButtonItems,
                  onClick: handleMenuClick,
                }}
                trigger={['click']}
                onClick={handleSaveAndPublishClick}
                style={{ marginLeft: 8 }}
              >
                Save & Publish
              </Dropdown.Button>
            )}
          </div>

        </>
      }
    >
      <Form layout="vertical" form={form}>
        <StatusBadge
          status={form.getFieldValue("status")}
          lastEdited={data.lastUpdated}
        />
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlex" : ""}`}>
          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Kit Name&nbsp;                 
                </span>
              }
              name="KitName"
              rules={[{ required: true, whitespace: true, message: "Please enter Kit name" }]}
            >
              <Input placeholder="Enter New Kit Product" onChange={handleBlur} maxLength={150}/>
            </Form.Item>
          </div>
          <Flex className={`flexbox ${isExpanded ? "w-33" : ""}`}>
            <Form.Item label={
              <span>
                Store&nbsp;               
              </span>} name="store" className="disabledstore">
              <Input placeholder="Enter a Store" disabled />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  BC Sku&nbsp;                 
                </span>
              }
              name="sapSku"
              className="sap_sku_select"             
                rules={[
                  { required: true, message: "Please Select BC Sku" },
                ]}
            >
              <Input
                style={{ width: "100%" }}
                placeholder="Enter BC Sku"

              />
            </Form.Item>

          </Flex>
          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Product Categories&nbsp;                  
                </span>
              }

              rules={[{ required: true, message: "Please select at least one category" }]}
            >

              <TreeSelect
                className="CategoryTree"
                multiple
                treeData={treeData}
                value={selectedValues}
                onChange={onChange}
                placeholder="Select categories"
              />
            </Form.Item>
          </div>
        </div>
        <Form.Item
          label={
            <span>
              PDP Image&nbsp;             
            </span>
          }
          name="Dropdown Thumbnail"
        >
          <UploadButton
            setSavedimgaes={setSavedimgaes}
            product_obj={thumbnailObj}
            MAX_UPLOADS="500"
            delete="true"
            replace="true"
            thumbnail="false"
            hover=""
          />
        </Form.Item>


        {/* Dropdown button */}
        <div className="DropdownButtonSection">
          <Text className="DropdownButtonSectionText">Dropdown button</Text>
          <span className="spanLine"></span>
        </div>
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlex" : ""}`}>

          <div className={`${isExpanded ? "w-50" : ""}`}>
            <Form.Item
              label={
                <span>
                  Dropdown Text&nbsp;                 
                </span>
              }
              name="DropdownText"
              rules={[{ required: true, whitespace: true, message: "Please enter Dropdown Text" }]}
            >
              <Input placeholder="Enter Dropdown Text" />
            </Form.Item>
          </div>

          <div className={`${isExpanded ? "w-50" : ""}`}>
            <Form.Item
              label="Discount Value"
              name="DiscountValue"
              rules={[
                { required: true, whitespace: true, message: "Please enter Discount Value" },
                {
                  validator: (_, value) => {
                    if (value === undefined || value === "") {
                      return Promise.resolve(); // handled by 'required'
                    }
                    const numericValue = parseFloat(value);
                    if (numericValue < 1 || numericValue > 100) {
                      return Promise.reject("Value must be between 1 and 100");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                placeholder="Enter Discount Value"
                style={{ width: "100%" }}
                value={data.discount_value}
                onChange={handleInputChange("DiscountValue")}
                addonAfter="%"
              />
            </Form.Item>

          </div>
        </div>
        <Form.Item
          label={
            <span>
              Dropdown Image&nbsp;              
            </span>
          }
          name="PDPGallery"
        >
          {visible && <UploadButton
            setSavedimgaes={setSavedDropdownImage}
            product_obj={dropdownImage}
            MAX_UPLOADS="1"
            delete="true"
            replace="true"
            thumbnail="false"
            hover="false"
          />}
        </Form.Item>

        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
          {visible && <CommonAttributeList setRemovedValues={setRemovedValues} setSavedattributes={setSavedattributes} customfielddata={data} setHasAttributeError={setHasAttributeError} />}
        </div>
        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes VariantProductList" : ""}`} style={{ marginTop: "16px" }}>
          {visible && <KitProductList kitProduct={data} form={form} setInnerProducts={setInnerProducts} />}
        </div>


      </Form>
    </Drawer>
  );
};

export default KitDrawer;
